import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';
import { ConfigProvider } from './contexts/ConfigContext';
import { SystemProvider } from './contexts/SystemContext';
import { ThemeFromConfig } from './themeFromConfig';
import { NotificationProvider } from './components/NotificationProvider';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import PortalResultados from './pages/PortalResultados';
import PortalCotizacion from './pages/PortalCotizacion';
import TableroCitas from './pages/TableroCitas';
import PrivateRoute from './components/PrivateRoute';
import LicenseBootstrap from './components/LicenseBootstrap';
import GeneradorLicencias from './pages/GeneradorLicencias';
import { usePreventNumberInputWheel } from './hooks/usePreventNumberInputWheel';

/** Rutas privadas del módulo clínica (/clinica/*): ver Dashboard.tsx + ClinicaModuleGuard. */

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
    },
  },
});

function App() {
  usePreventNumberInputWheel();

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SocketProvider>
          <ConfigProvider>
            <SystemProvider>
            <ThemeFromConfig>
              <NotificationProvider>
              <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                <LicenseBootstrap>
                  <Routes>
                    <Route path="/generador-licencias" element={<GeneradorLicencias />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/portal/resultados" element={<PortalResultados />} />
                    <Route path="/portal/cotizacion" element={<PortalCotizacion />} />
                    <Route path="/tablero-citas" element={<TableroCitas />} />
                    <Route
                      path="/*"
                      element={
                        <PrivateRoute>
                          <Dashboard />
                        </PrivateRoute>
                      }
                    />
                  </Routes>
                </LicenseBootstrap>
              </Router>
              </NotificationProvider>
            </ThemeFromConfig>
            </SystemProvider>
          </ConfigProvider>
        </SocketProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;

